import { combineReducers } from 'redux';
import vdc from './vdc/vdcReducer';

export default combineReducers({
	vdc,
});
